import { FC, memo, useState } from "react"
import { FiatItem } from "./FiatItem"
import { CardType, CurrencyDto, CurrencyType } from "./HeroBlock"

const CardItem = ({
  title,
  description,
  isActive,
  isFirst,
  onClick,
}: {
  title: string
  isFirst?: boolean
  description: string
  onClick: () => void
  isActive: boolean
}) => (
  <div
    style={{
      padding: "14px",
      display: "flex",
      gap: "14px",
      borderBottom: isFirst ? "1px solid #D7D7D7" : "none",
      backgroundColor: isActive ? "#EDEDED" : undefined,
    }}
    onClick={onClick}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "40px",
        maxWidth: "40px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: "#E41E1F",
      }}
    >
      <img src={`/img/icons_new/card_icon.svg`} alt="" />
    </div>

    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <span
        style={{
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 800,
          letterSpacing: "-0.36px",
        }}
      >
        {title}
      </span>
      <span
        style={{
          fontSize: "14px",
          lineHeight: "145%",
          fontWeight: 500,
          letterSpacing: "-0.28px",
          color: "#8F8F8F",
        }}
      >
        {description}
      </span>
    </div>
  </div>
)

const CurrencyButton = ({ isOpen, onClick, title }: { isOpen: boolean; title: string; onClick: () => void }) => (
  <div
    style={{
      padding: "12px 12px 12px 20px",
      borderRadius: "10px",
      backgroundColor: "#EDEDED",
      display: "flex",
      gap: "14px",
      alignSelf: "flex-start",
      alignItems: "center",
      height: "50px",
    }}
    onClick={onClick}
  >
    <span
      style={{
        fontSize: "18px",
        lineHeight: "145%",
        fontWeight: 800,
        letterSpacing: "-0.36px",
      }}
    >
      {title}
    </span>
    <div
      style={{
        width: "8px",
        height: "5px",
        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
        background: "url(../img/dropdown-b.svg) 98% center no-repeat",
      }}
    />
  </div>
)

type Props = {
  currency: CurrencyDto | null | undefined
  currencies: CurrencyType[]
  cardType: CardType
  onCardTypeChange: (cardType: CardType) => void
  onFiatCurrencyChange: (currency: CurrencyDto) => void
}

const CardsItemComponent: FC<Props> = ({ currencies, currency, onFiatCurrencyChange, cardType, onCardTypeChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  console.log(currency)

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        padding: "20px",
        gap: "12px",
      }}
    >
      <CurrencyButton isOpen={isOpen} title={currency?.code ?? ""} onClick={() => setIsOpen((x) => !x)} />

      <span
        style={{
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 600,
          letterSpacing: "-0.36px",
        }}
      >
        Select how you want to get paid
      </span>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          border: "1px solid #D7D7D7",
          overflow: "hidden",
          borderRadius: "10px",
        }}
      >
        <CardItem
          isActive={cardType === "1"}
          title="Debit Card"
          isFirst
          description="$5 – $20,000 per tx"
          onClick={() => onCardTypeChange("1")}
        />
        <CardItem isActive={cardType === "2"} title="Credit Card" description="$5 – $20,000 per tx" onClick={() => onCardTypeChange("2")} />
      </div>

      {isOpen ? (
        <div
          style={{
            position: "absolute",
            top: "82px",
            left: "20px",
            right: "20px",
            bottom: "20px",
            border: "1px solid #CBCBCB",
            borderRadius: "10px",
            backgroundColor: "#ffffff",
          }}
        >
          {currencies.map((x) => (
            <FiatItem
              key={x.value}
              isActive={x.value === currency.code}
              currency={x.value}
              name={x.meta.name}
              onClick={() => {
                setIsOpen(false)
                onFiatCurrencyChange(x.meta)
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}

export const CardsItem = memo(CardsItemComponent)
